// cr_thuoc, cr_vtyt, cr_hc
const API_URL = "https://api135.goodapp.vn/api";
const PUBLIC_URL = "https://api135.goodapp.vn";
const ID_APP = "6705e2081f1f0f181e3d53e6"; // dumuc
const PUBLIC_TOKEN = "flex.public.token";

const DEFAULT_CUSTOMER = {
  ma_kh: "1",
  ten_kh: "Khách lẻ",
};
const DEFAULT_NCC = {
  ma_kh: "2",
  ten_kh: "Nội bộ",
};

const VIEW_RIGHT = "view";
const VIEWOFOTHER_RIGHT = "viewOfOther";
const ADD_RIGHT = "add";
const UPDATE_RIGHT = "update";
const DELETE_RIGHT = "delete";

export {
  API_URL,
  PUBLIC_URL,
  ID_APP,
  PUBLIC_TOKEN,
  DEFAULT_CUSTOMER,
  DEFAULT_NCC,
  VIEW_RIGHT,
  VIEWOFOTHER_RIGHT,
  ADD_RIGHT,
  UPDATE_RIGHT,
  DELETE_RIGHT,
};
